/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestDeleteUserRequest } from './RequestDeleteUserRequest';
import {
    RequestDeleteUserRequestFromJSON,
    RequestDeleteUserRequestFromJSONTyped,
    RequestDeleteUserRequestToJSON,
    RequestDeleteUserRequestToJSONTyped,
} from './RequestDeleteUserRequest';

/**
 * 
 * @export
 * @interface RequestDeleteUserRequestWrapper
 */
export interface RequestDeleteUserRequestWrapper {
    /**
     * 
     * @type {Array<RequestDeleteUserRequest>}
     * @memberof RequestDeleteUserRequestWrapper
     */
    req?: Array<RequestDeleteUserRequest>;
}

/**
 * Check if a given object implements the RequestDeleteUserRequestWrapper interface.
 */
export function instanceOfRequestDeleteUserRequestWrapper(value: object): value is RequestDeleteUserRequestWrapper {
    return true;
}

export function RequestDeleteUserRequestWrapperFromJSON(json: any): RequestDeleteUserRequestWrapper {
    return RequestDeleteUserRequestWrapperFromJSONTyped(json, false);
}

export function RequestDeleteUserRequestWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeleteUserRequestWrapper {
    if (json == null) {
        return json;
    }
    return {
        
        'req': json['req'] == null ? undefined : ((json['req'] as Array<any>).map(RequestDeleteUserRequestFromJSON)),
    };
}

export function RequestDeleteUserRequestWrapperToJSON(json: any): RequestDeleteUserRequestWrapper {
    return RequestDeleteUserRequestWrapperToJSONTyped(json, false);
}

export function RequestDeleteUserRequestWrapperToJSONTyped(value?: RequestDeleteUserRequestWrapper | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'req': value['req'] == null ? undefined : ((value['req'] as Array<any>).map(RequestDeleteUserRequestToJSON)),
    };
}

